module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-20"
  }, [_c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Panel', {
    attrs: {
      "type": "success"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("启用作业数 / 总作业数")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v(_vm._s(_vm.jobTotalInfo.enabledNumber) + " / " + _vm._s(_vm.jobTotalInfo.totalNumber))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a', {
    on: {
      "click": _vm.toAbnormalJobPage
    }
  }, [_c('Panel', {
    attrs: {
      "type": "danger"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("异常作业数")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v(_vm._s(_vm.jobTotalInfo.abnormalNumber))])])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('FilterPageList', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.tableLoading),
      expression: "tableLoading"
    }],
    ref: "pageListRef",
    attrs: {
      "get-data": _vm.getJobList,
      "total": _vm.total,
      "order-by": _vm.orderBy,
      "filters": _vm.filters,
      "element-loading-text": "请稍等···"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "table-filter",
          attrs: {
            "inline": true
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "140px"
          },
          on: {
            "change": scope.search
          },
          model: {
            value: (_vm.filters.groups.value),
            callback: function($$v) {
              _vm.$set(_vm.filters.groups, "value", $$v)
            },
            expression: "filters.groups.value"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "全部分组",
            "value": ""
          }
        }), _vm._v(" "), _vm._l((_vm.groupList), function(item) {
          return _c('el-option', {
            key: item,
            attrs: {
              "label": item,
              "value": item
            }
          })
        })], 2)], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "140px"
          },
          on: {
            "change": scope.search
          },
          model: {
            value: (_vm.filters.status.value),
            callback: function($$v) {
              _vm.$set(_vm.filters.status, "value", $$v)
            },
            expression: "filters.status.value"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "全部状态",
            "value": ""
          }
        }), _vm._v(" "), _vm._l((_vm.$option.jobStatusTypes), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        })], 2)], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": _vm.filterColumnPlaceholder
          },
          nativeOn: {
            "keyup": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
              scope.search($event)
            }
          },
          model: {
            value: (_vm.filters[_vm.selectColumn].value),
            callback: function($$v) {
              _vm.$set(_vm.filters[_vm.selectColumn], "value", (typeof $$v === 'string' ? $$v.trim() : $$v))
            },
            expression: "filters[selectColumn].value"
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "120px"
          },
          attrs: {
            "slot": "prepend"
          },
          on: {
            "change": _vm.selectColumnChange
          },
          slot: "prepend",
          model: {
            value: (_vm.selectColumn),
            callback: function($$v) {
              _vm.selectColumn = $$v
            },
            expression: "selectColumn"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "作业名",
            "value": "jobName"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "作业描述",
            "value": "description"
          }
        })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-search"
          },
          on: {
            "click": scope.search
          }
        }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.loading),
            expression: "loading"
          }],
          staticClass: "page-table",
          attrs: {
            "element-loading-text": "请稍等···"
          }
        }, [_c('div', {
          staticClass: "page-table-header"
        }, [_c('div', {
          staticClass: "page-table-header-title"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v("作业列表\n                            "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": scope.search
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table-header-separator"
        }), _vm._v(" "), _c('div', [(_vm.$common.hasPerm('job:batchEnable', _vm.domainName)) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.batchEnabled()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-play-circle text-btn"
        }), _vm._v("启用")]) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:batchDisable', _vm.domainName)) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.batchDisabled()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-stop-circle text-warning"
        }), _vm._v("禁用")]) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:batchRemove', _vm.domainName)) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.batchDelete()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash text-danger"
        }), _vm._v("删除")]) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:batchSetPreferExecutors', _vm.domainName)) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.batchPriority()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-level-up text-btn"
        }), _vm._v("优先")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "pull-right"
        }, [(_vm.$common.hasPerm('job:add', _vm.domainName)) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.handleAdd()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus-circle text-btn"
        }), _vm._v("添加")]) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:import', _vm.domainName)) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.handleImport()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-circle-o-down text-btn"
        }), _vm._v("导入")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          on: {
            "click": function($event) {
              _vm.handleExport()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-circle-o-up text-btn"
        }), _vm._v("导出")]), _vm._v(" "), _c('el-button', {
          on: {
            "click": function($event) {
              _vm.handleArrangeLayout()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-line-chart text-btn"
        }), _vm._v("作业依赖图")])], 1)]), _vm._v(" "), _c('el-table', {
          ref: "multipleTable",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "stripe": "",
            "border": "",
            "data": _vm.jobList
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "sort-change": scope.onSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "jobName",
            "label": "作业名",
            "sortable": "custom"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('router-link', {
                attrs: {
                  "tag": "a",
                  "to": {
                    name: 'job_setting',
                    params: {
                      domain: _vm.domainName,
                      jobName: scope.row.jobName
                    }
                  }
                }
              }, [(scope.row.jobType === 'JAVA_JOB' || scope.row.jobType === 'PASSIVE_JAVA_JOB') ? _c('i', {
                staticClass: "iconfont icon-java"
              }) : _vm._e(), _vm._v(" "), (scope.row.jobType === 'SHELL_JOB' || scope.row.jobType === 'PASSIVE_SHELL_JOB') ? _c('i', {
                staticClass: "iconfont icon-msnui-logo-linux"
              }) : _vm._e(), _vm._v(" "), (scope.row.jobType === 'MSG_JOB') ? _c('i', {
                staticClass: "fa fa-envelope-o"
              }) : _vm._e(), _vm._v("\n                                    " + _vm._s(scope.row.jobName) + "\n                                ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "jobType",
            "label": "作业类型",
            "width": "100px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v(" \n                                " + _vm._s(_vm.$map.jobTypeMap[scope.row.jobType]) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "状态",
            "prop": "status",
            "width": "90px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tag', {
                attrs: {
                  "type": _vm.statusTag[scope.row.status],
                  "close-transition": ""
                }
              }, [_vm._v(_vm._s(_vm.$map.jobStatusMap[scope.row.status]))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "description",
            "show-overflow-tooltip": "",
            "label": "描述"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v(" \n                                " + _vm._s(scope.row.description) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "groups",
            "label": "分组",
            "width": "120px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "shardingTotalCount",
            "label": "分片数",
            "width": "70px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "shardingList",
            "label": "是否已分配分片",
            "width": "130px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shardingList === '') ? _c('span', [_vm._v("-")]) : _c('el-tag', {
                attrs: {
                  "type": scope.row.shardingList === '已分配' ? 'primary' : ''
                }
              }, [_vm._v(_vm._s(scope.row.shardingList))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "120px",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.$common.hasPerm('job:enable', _vm.domainName) && (scope.row.status === 'STOPPING' || scope.row.status === 'STOPPED')) ? _c('el-tooltip', {
                attrs: {
                  "content": "启用",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    _vm.handleActive(scope.row, true)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-play-circle"
              })])], 1) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:disable', _vm.domainName) && (scope.row.status === 'READY' || scope.row.status === 'RUNNING')) ? _c('el-tooltip', {
                attrs: {
                  "content": "禁用",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    _vm.handleActive(scope.row, false)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-stop-circle text-warning"
              })])], 1) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:copy', _vm.domainName)) ? _c('el-tooltip', {
                attrs: {
                  "content": "复制",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    _vm.handleCopy(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-clone"
              })])], 1) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:remove', _vm.domainName) && scope.row.status === 'STOPPED') ? _c('el-tooltip', {
                attrs: {
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text",
                  "icon": "el-icon-delete text-danger"
                },
                on: {
                  "click": function($event) {
                    _vm.handleDelete(scope.row)
                  }
                }
              })], 1) : _vm._e()]
            }
          }])
        })], 1)], 1)]
      }
    }])
  }), _vm._v(" "), (_vm.isJobInfoVisible) ? _c('div', [_c('job-info-dialog', {
    attrs: {
      "domain-name": _vm.domainName,
      "job-info": _vm.jobInfo,
      "job-info-title": _vm.jobInfoTitle,
      "job-info-operation": _vm.jobInfoOperation
    },
    on: {
      "job-info-success": _vm.jobInfoSuccess,
      "close-dialog": _vm.closeDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isBatchPriorityVisible) ? _c('div', [_c('batch-priority-dialog', {
    attrs: {
      "job-names-array": _vm.jobNamesArray,
      "domain-name": _vm.domainName
    },
    on: {
      "close-dialog": _vm.closePriorityDialog,
      "batch-priority-success": _vm.batchPrioritySuccess
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isImportVisible) ? _c('div', [_c('ImportFileDialog', {
    attrs: {
      "import-data": _vm.importData,
      "import-template-url": "/console/static/jobTemplate/download",
      "import-url": _vm.importUrl,
      "import-title": "导入作业"
    },
    on: {
      "close-dialog": _vm.closeImportDialog,
      "import-success": _vm.importSuccess
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isImportResultVisible) ? _c('div', [_c('import-result-dialog', {
    attrs: {
      "import-result": _vm.importResult
    },
    on: {
      "close-dialog": _vm.closeImportResultDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isArrangeLayoutVisible) ? _c('div', [_c('arrange-layout-dialog', {
    attrs: {
      "arrange-layout-info": _vm.arrangeLayoutInfo
    },
    on: {
      "job-redirect": _vm.jobRedirect,
      "close-dialog": _vm.closeArrangeLayoutDialog
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd28a054"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/job_list/job_overview.vue
// module id = 1445
// module chunks = 1